export const capitalize = (text) => {
    return text
        .trimLeft()
        .toLowerCase()
        .split(" ")
        .map((n) => `${n.charAt(0).toUpperCase()}${n.substring(1)}`)
        .join(" ");
};
export const formatName = (name = "", lettersOnly = true) => {
    const clean = lettersOnly ? name.replace(/[^A-Za-z- ]/g, "") : name;
    return capitalize(clean);
};

export const formatRut = (text) => {
    const stripZero = text.replace(/^0+/, ""); // deletes starting 0 if exists ex 09000 becomes 9000

    const rut = stripZero.replace(/[^kK0-9]/g, "");

    if (rut.length > 1) {
        const stripDots = rut.replace(/\./g, "");
        const stripDash = stripDots.replace(/-/g, "");
        const start = stripDash.substr(0, stripDash.length - 1);
        const verifyer = stripDash.charAt(stripDash.length - 1);
        const dotSeparated = addDots(start.replace(/[^0-9]/g, ""));
        const formatedRut = `${dotSeparated}-${verifyer}`;

        return formatedRut;
    }

    return rut;
};

export const formatRutWithoutHyphen = (text) => {
    return formatRut(text)
        .replace(/^0+/g, "")
        .replace(/[^0-9Kk]/g, "");
};

export const formatRutWithHyphen = (text) => {
    const length = text.length;
    const lastChar = text.slice(length - 1);
    return [text.slice(0, length - 1), "-", lastChar].join("");
};

export const formatIdserial = (text) => {
    const stripZero = text.replace(/^0+/, ""); // deletes starting 0 if exists ex 09000 becomes 9000
    const serial = stripZero.toUpperCase().replace(/[^A0-9]/g, "");
    if (serial.length < 1) return serial;
    const start = serial[0];
    const rest = serial.substr(1, serial.length).replace(/[^0-9]/g, "");
    return start + rest + "";
};
export const formatDate = (text) => {
    const preformatted = text.replace(/[^0-9]/g, "");

    const noSlashes = preformatted.split("/").join("");

    if (noSlashes.length >= 3 && noSlashes.length <= 4) {
        const day = noSlashes.substring(0, 2);
        const month = noSlashes.substring(2, noSlashes.length);

        return day + "/" + month;
    } else if (text.length > 4) {
        const day = noSlashes.substring(0, 2);
        const month = noSlashes.substring(2, 4);
        const year = noSlashes.substring(4, text.length);

        return day + "/" + month + "/" + year;
    } else {
        return preformatted;
    }
};

export const formatAmount = (input) => {
    if (input !== null && input !== "undefined") {
        const numberWithoutFormat = input.toString().replace(/[^0-9]/g, "");
        const stripZero = numberWithoutFormat.replace(/^0+/, "");
        if (stripZero === "") return "";
        const amount = addDots(stripZero);
        return "$" + amount;
    }
};

export const addDots = (input = "") =>
    input
        .toString()
        .split("")
        .reverse()
        .reduce((prev, curr, i) => {
            if (i > 0 && i % 3 === 0) {
                return [curr, ".", ...prev];
            }
            return [curr, ...prev];
        }, [])
        .join("");

export const formatNumber = (number) => {
    if (number) {
        number = number.replace(/[^0-9]/g, "");
    }
    return number;
};

export const formatEmail = (email) => {
    if (email) {
        //mail = email.toLowerCase().replace(/[^A-Za-z_.@0-9 ]/g, "");
    }
    return email;
};

export const obfuscatedEmail = (email) => {
    if (email != null && email.length > 0) {
        const nameEmail = email.split("@")[0];
        const emailCompany = email.split("@")[1];
        const obfuscatedEmail = nameEmail.replace(
            nameEmail.substring(nameEmail.length / 3, nameEmail.length),
            "········"
        );

        return `${obfuscatedEmail}@${emailCompany}`;
    } else {
        return "";
    }
};
